import { useContext, useEffect } from "react";
import { Navigate } from "react-router-dom";
import CustomSpinner from "../components/CustomSpinner";
import LoginComponent from "../components/LoginComponent";
import UserContext from "../context/UserContext";



export default function Dashboard() {
  const { user, loading, setLoading } = useContext(UserContext);

  useEffect(() => {
    if (!user) {
      setLoading(false);
      return;
    }

  }, [user, setLoading]);

  // un bg muy chido 
  // bg-[radial-gradient(circle_at_top,_rgba(59,130,246,0.12),_transparent_50%)]
  return (
    <>
      {loading && <CustomSpinner />}
      {user === null ? (
        <div className="min-h-[91vh] banner-1 px-4 py-5 sm:px-6 lg:px-8">
          <div className="mx-auto flex max-w-6xl justify-center">
            <LoginComponent />
          </div>
        </div>
      ) : (
        <Navigate to="/customers" replace />
      )}
    </>
  );
}